import React, { Component } from 'react'
import { connect } from 'react-redux'
import { signOut } from '../../../store/actions'
import { withRouter, Redirect } from 'react-router-dom'

class Logout extends Component {
  componentDidMount = () => {
    this.mounted = true
    this.props.signOut()
  }

  render() {
    return <Redirect to='/login' />
  }
}

const mapDispatchToProps = dispatch => {
  return {
    signOut: () => dispatch(signOut())
  }
}

export default connect(null, mapDispatchToProps)(withRouter(Logout))
